<div class="transfer-search">
  <div class="search">
    <div class="form-group">
      <input
        #searchinput
        type="number"
        min="0"
        step="1"
        pattern="[0-9]*"
        inputmode="numeric"
        class="search form-control"
        [(ngModel)]="search"
        placeholder="Add tool id"
        (keyup.enter)="handleSubmit($event)"
        (blur)="handleSubmit($event)"
         />
      <button type="button">
        <i class="fal fa-search"></i>
      </button>
    </div>
  </div>
</div>
